import React from 'react';
import address_map from '../images/address-map.jpg'
import address_icon from '../images/address-icon.png'
import email_icon from '../images/email-icon.png'
import contact_icon from '../images/contact-icon.png'
import CellPhone from './CellPhone'
import './ContactUs.css'
import Board from "./Board";
import CSService from "./CSService";
import ContactTitle, {CTText, CTTitle} from "./ContactTitle";
import GroupTitle, {GroupTitileOrange, GroupTitleBackground, GroupTitleText} from "../company/GroupTitle";
import bottom_bg from "../images/bottom-bg.jpg";

export default function ContactUs() {
    return (
        <div>
            <div className='contact-us-container'/>
            <img className='bg-2' src={bottom_bg} alt='bottom-bg'/>
            <div className='contact-us'>
                <div className='container'>
                    <div className='title'>
                        <GroupTitle>
                            <GroupTitleBackground>contact us</GroupTitleBackground>
                            <GroupTitleText>
                                <span>联系</span>
                                <GroupTitileOrange>我们</GroupTitileOrange>
                            </GroupTitleText>
                        </GroupTitle>
                    </div>
                    <CellPhone/>
                    <Board/>
                    <CSService/>
                    <div className='contact'>
                        <ContactTitle src={contact_icon}>
                            <CTTitle>
                                咨询方式
                            </CTTitle>
                            <CTText>
                                联系电话：010-82465472
                            </CTText>
                            <CTText>
                                传 真：010-82465472
                            </CTText>
                        </ContactTitle>
                    </div>
                    <div className='email'>
                        <ContactTitle src={email_icon}>
                            <CTTitle>
                                邮箱
                            </CTTitle>
                            <CTText>
                                zyw@gsde.ltd
                            </CTText>
                        </ContactTitle>
                    </div>
                    <div className='address'>
                        <div className='address-header'>
                            <ContactTitle src={address_icon}>
                                <CTTitle>
                                    地址
                                </CTTitle>
                                <CTText>
                                    北京市昌平区回龙观镇建材城西路87号院8号楼20层1-2310
                                </CTText>
                            </ContactTitle>
                        </div>
                        <img className='address-map' src={address_map} alt='address-map'/>
                    </div>
                </div>
            </div>
        </div>
    )
}